module.exports = __webpack_public_path__ + "9a39419b6172ac018cdcbdeaaf5f7467.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/footer/hotline.png
// module id = ./assets/images/footer/hotline.png
// module chunks = 0